export enum Tenants {
  AllTenants = 'all-tenants', // do not change string value, it is used in emails sent by the server
  AllWorkflows = 'all-workflows', // do not change string value, it is used in emails sent by the server
}

export enum ModuleType {
  Monitoring = 'monitoring',
  Orchestration = 'orchestration',
  Analytics = 'analytics',
  Reporting = 'reporting',
  Workflows = 'workflows',
  Admin = 'admin',
  Settings = 'settings',
  Auth = 'auth',
  NotFound = 'not-found',
  Initialization = 'initialization',
  RpaNotConnected = 'rpa-not-connected',
  Administration = 'administration',
}

export enum PageType {
  // Monitoring
  Processes = 'processes',
  Resources = 'resources',
  ResourceGroups = 'resource-groups',
  Credentials = 'credentials',
  CredentialPools = 'credential-pools',
  Sessions = 'sessions',
  Utilization = 'utilization',
  PastSchedule = 'past-schedule',

  // Orchestration
  Alerts = 'alerts',
  EventLog = 'event-log',
  AuditLog = 'audit-log',
  ProcessConfiguration = 'process-configuration',
  Debug = 'debug',
  Calendar = 'calendar',
  ExternalSystems = 'external-systems',
  DumpViewer = 'dump-viewer',

  // Analytics
  DetectedIncidents = 'detect-incidents',
  DiagnosticDashboard = 'diagnostic-dashboard',
  RuntimeAnalysis = 'runtime-analysis',
  Anomalies = 'anomalies',

  // Reporting
  ExecutiveOverview = 'executive-overview',
  ProcessReporting = 'process-reporting',
  MonthlyReports = 'monthly-reports',
  BenchmarkOverview = 'benchmarking',

  // Workflows
  Workflows = 'workflows',
  WorkflowRuns = 'workflow-runs',
  WorkflowWorkTeams = 'workflow-work-teams',
  WorkflowWorkItems = 'workflow-work-items',
  WorkflowApis = 'workflow-apis',
  WorkflowForms = 'workflow-forms',
  WorkflowAgents = 'workflow-agents',
  WorkflowEmailTemplates = 'workflow-email-templates',

  // Settings
  OrganizationSettings = 'organization-settings',

  // Admin
  Organizations = 'organizations',
  Users = 'users',
  Licenses = 'licenses',

  // Auth
  Login = 'login',

  // Administration (internal tools)
  DesignSystemOverview = 'design-system-overview',
  Tooling = 'tooling',
}

export enum SubPageType {
  // Utilization
  Licenses = 'licenses',
  Resources = 'resources',
  OrchestrationTasks = 'orchestration-tasks',
  Processes = 'processes',
  Sessions = 'sessions',
  EventLog = 'event-log',
  LicenseUtilization = 'license-utilization',
  ResourceUtilization = 'resource-utilization',
  PastSchedule = 'past-schedule',
  // RuntimeAnalysis
  Overview = 'overview',
  ActionableInsights = 'actionable-insights',
  ProcessMap = 'process-map',
  VariantAnalysis = 'variant-analysis',
  CostAnalysis = 'cost-analysis',
  AnalysisNotFound = 'analysis-not-found',
  // Organization Settings
  GeneralSettings = 'general-settings',
  ProcessesSettings = 'processes-settings',
  ResourcesSettings = 'resources-settings',
  QueuesSettings = 'queues-settings',
  BusinessProcessesSettings = 'business-processes-settings',
  SavingsSettings = 'savings',
  GroupsSettings = 'groups',
  BillingGroupsSettings = 'billing-groups',
  PendingSessions = 'pendings',
  ExternalServicesSettings = 'external-services',
  UsersSettings = 'users',
  ReportingSettings = 'reporting',
  BenchmarkingSettings = 'benchmarking',
  NotificationsSettings = 'notifications',
  ConditionStates = 'condition-states',
  TenantsSettings = 'tenants',
  ApiCredentialsSettings = 'api-credentials',
  AiProvidersSettings = 'ai-providers',
  MsTeamsSettings = 'ms-teams',
  OrchestrationDebugging = 'orchestration-debugging',
  AnomaliesSettings = 'anomalies-settings',
  ImportExportSettings = 'import-export-settings',
  // DumpViewer
  DumpViewer = 'dump-viewer',
  Queues = 'queues',
  Calendar = 'calendar',
  // Process reporting
  ProcessReportList = 'report-list',
  ProcessReportDetail = 'report-detail',
  ProcessReportingNotFound = 'process-not-found',
}

export const OrganizationSettingsSubPageTypes = [
  SubPageType.GeneralSettings,
  SubPageType.ProcessesSettings,
  SubPageType.ResourcesSettings,
  SubPageType.QueuesSettings,
  SubPageType.BusinessProcessesSettings,
  SubPageType.SavingsSettings,
  SubPageType.GroupsSettings,
  SubPageType.BillingGroupsSettings,
  SubPageType.PendingSessions,
  SubPageType.ExternalServicesSettings,
  SubPageType.UsersSettings,
  SubPageType.ReportingSettings,
  SubPageType.BenchmarkingSettings,
  SubPageType.NotificationsSettings,
  SubPageType.ConditionStates,
  SubPageType.TenantsSettings,
  SubPageType.ApiCredentialsSettings,
  SubPageType.AiProvidersSettings,
  SubPageType.OrchestrationDebugging,
  SubPageType.AnomaliesSettings,
  SubPageType.ImportExportSettings,
];
export type OrganizationSettingsSubPageType = typeof OrganizationSettingsSubPageTypes[number];
